module.exports = "/images/vendor/flag-icon-css/flags/4x3/bh.svg?ef135f3ca77838cbb6e329d57d250c9a";